module.exports = __webpack_public_path__ + "static/media/helper-shopify-2.4a163ce0.png";